import { IbRepoStatusPillInterface } from '../interfaces/ib-repo-status-pill.interface';
import { IbRepoVerificationStateInterface } from '../interfaces/ib-repo-verification-state.interface';

/**
 * Maps the IB repo verification state to the status badge.
 * The badge shows 'Verifying' while the panel is open. A user with the verify role can click the badge to open the panel.
 */
export function mapIbRepoStatusPill(
  state: IbRepoVerificationStateInterface | null,
  canVerify: boolean,
  isPanelOpen: boolean,
): IbRepoStatusPillInterface | null {
  if (!state || state.status === 'none') {
    return null;
  }

  if (isPanelOpen) {
    return { label: 'Verifying', theme: 'blue-light', icon: '', isAction: false, ariaLabel: null };
  }

  const isVerified = state.status === 'verified';

  if (!canVerify) {
    return { label: state.badgeLabel, theme: state.badgeTheme, icon: state.badgeIcon, isAction: false, ariaLabel: null };
  }

  return {
    label: isVerified ? state.badgeLabel : state.actionText,
    theme: state.badgeTheme,
    icon: state.badgeIcon,
    isAction: true,
    ariaLabel: isVerified ? `IB repo hours verified. ${state.actionText}` : `${state.actionText}. ${state.description}`,
  };
}
